<template>
    <a href="#"
           class="flex items-center gap-1 text-brand-dark hover:text-brand-red transition-colors py-6"
           @mouseenter="$emit('hover')"
           @focus="$emit('hover')">
            {{ title }} <ChevronDownIcon />
        </a>
</template>
<script>
import { ChevronDownIcon } from './icons/';
export default{
    props: ['title'],
    components: { ChevronDownIcon },
}
</script>